<template>
  <CContainer>
    <CRow class="justify-content-center mt-4 mb-4">
      <CCol md="12" class="text-start">
        <div class="d-flex align-items-center">
          <h2>Digital ID Card</h2>
          <HelpCenterButton
            classes="ms-4"
            content-key="module_digital_id_card"
          />
        </div>
        <div>
          <CCheckBox
            label="QR Code As Default"
            v-model="form.qrCode"
            @update:model-value="checkQr"
            class="custom-checkbox text-start"
            :custom="true"
          />

          <CCheckBox
            label="Barcode As Default"
            v-model="form.barcode"
            @update:model-value="checkBarcode"
            class="custom-checkbox text-start"
            :custom="true"
          />

          <CAlert
            v-if="reqResponse.message"
            class="mt-4"
            :color="reqResponse.type"
            :show="!!reqResponse.message"
          >
            {{ reqResponse.message }}
          </CAlert>
        </div>
      </CCol>
    </CRow>
  </CContainer>
</template>

<script>
import HelpCenterButton from "../HelpCenterButton"
import { mapGetters, mapState } from "vuex"
import _ from "underscore"

export default {
  name: "DigitalIdCardForm",
  components: { HelpCenterButton },
  data() {
    return {
      isLoading: false,
      form: {
        qrCode: false,
        barcode: false
      },
      reqResponse: {
        type: "",
        message: "",
        errors: {}
      }
    }
  },
  computed: {
    ...mapGetters({
      activeSchoolModules: "schools/activeSchoolModules"
    }),
    ...mapState({
      options: (state) => {
        const index = _.findIndex(state.schools.activeSchoolModules, {
          name: "Digital ID Card"
        })
        return index !== -1
          ? JSON.parse(
              state.schools.activeSchoolModules[index].pivot.option_json
            )
          : false
      }
    })
  },
  mounted() {
    if (this.options) {
      this.form.qrCode = Boolean(this.options.qr_code_as_default)
      this.form.barcode = Boolean(this.options.barcode_as_default)
    }
  },
  methods: {
    checkBarcode(value) {
      this.form.barcode = value
      this.form.qrCode = false
      this.submit()
    },
    checkQr(value) {
      this.form.qrCode = value
      this.form.barcode = false
      this.submit()
    },
    submit() {
      this.resetResponseMessages()
      const inputsData = JSON.stringify({
        barcode_as_default: this.form.barcode,
        qr_code_as_default: this.form.qrCode
      })
      this.isLoading = true
      this.$store
        .dispatch("modules/updateIdCardModule", { option_json: inputsData })
        .then(() => {
          this.setSuccessResponse("Successfully updated.")
          this.$store
            .dispatch("schools/getActiveModules", {
              clearCacheEntry: true
            })
            .then(() => {
              this.form.barcode = Boolean(this.options.barcode_as_default)
              this.form.qrCode = Boolean(this.options.qr_code_as_default)
            })
          this.isLoading = false
          setTimeout(() => {
            this.resetResponseMessages()
          }, 850)
        })
        .catch((err) => {
          const response = err.response.data
          this.setErrorResponse(response.message, response.errors)
          this.isLoading = false
        })
    },
    resetResponseMessages() {
      this.reqResponse = {
        type: "",
        message: "",
        errors: {}
      }
    },
    setSuccessResponse(message) {
      this.reqResponse = {
        type: "success",
        message: message ? message : "Success!",
        errors: {}
      }
    },
    setErrorResponse(message, errors) {
      this.reqResponse = {
        type: "danger",
        message: message ? message : "Someting went wrong!",
        errors: errors ? errors : {}
      }
    }
  }
}
</script>

<style scoped></style>
